// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"ef8e8776","455":"492e6b75","527":"641a797c","977":"b0a4678a"}[chunkId] + ".chunk.js";
};